import type { NDateLocale } from './enUS'
import { gl } from 'date-fns/locale'

const dateGlES: NDateLocale = {
  name: 'gl-ES',
  locale: gl
}

export default dateGlES
